import {useNewProduct} from "../../../store/contexts/NewProductContext";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {TYPES} from "../../../store/reducers/NewProductReducer";
import StateTreeSelect from "../../../Components/Inputs/States/StateTreeSelect";

const flatten = arr => {
  let result = [];
  arr.forEach(function (item) {
    result.push(item);
    if (Array.isArray(item.children)) {
      result = result.concat(flatten(item.children));
    }
  });
  return result;
}

const ProductDetailsCard = () => {
  const {product, dispatch, errors} = useNewProduct();
  const [categories, setCategories] = useState([]);
  const productCategoryId = product?.category_id;
  const [selectedCategory, setSelectedCategory] = useState(null)

  useEffect(() => {
    axios.get('/categories-for-tree-select').then(response => {
      setCategories(response.data.categories)
    });
  }, []);


  const handleCategoryChange = (selected) => {
    dispatch({
      type: TYPES.SET_PRODUCT,
      payload: {...product, category_id: parseInt(selected)}
    });
  }

  return (
    <div className="card card-flush py-4">
      <div className="card-header">
        <div className="card-title">
          <h2>Product Details</h2>
        </div>
      </div>

      <div className="card-body pt-0">
        {
          categories?.length > 0 && (
            <StateTreeSelect
              label='Category'
              state={selectedCategory}
              setState={setSelectedCategory}
              options={categories}
              flattenedOptions={flatten(categories)}
              callback={(val) => handleCategoryChange(val)}
              value={productCategoryId}
              errorMessage={errors?.category_id}
            />
          )
        }

      </div>
    </div>
  )
}

export default ProductDetailsCard;